import React from "react";
import OutGoingRequestAppointmentCard from "../../../../components/requests/OutGoingRequestAppointmentCard";
import RequestsModel from "../../../../api/models/RequestsModel";

type OutGoingTabProps = {
  requests: RequestsModel[];
};
export const OutGoingTab = (props: OutGoingTabProps) => {
  const { requests } = props;
  return (
    <div className="w-full px-8 py-6 bg-white">
      <div className="flex flex-col gap-6">
        {requests.length > 0 &&
          requests.map((request) => (
            <OutGoingRequestAppointmentCard request={request} />
          ))}
      </div>
    </div>
  );
};
